import { GetOneCourseOutDto } from "../../../types/course.dto";

export const GET_ONE_COURSE = "GET_ONE_COURSE";
export const GET_ONE_COURSE_SUCCESS = "GET_ONE_COURSE_SUCCESS";
export const GET_ONE_COURSE_ERROR = "GET_ONE_COURSE_ERROR";
export const RESET_GET_ONE_COURSE = "RESET_GET_ONE_COURSE";

export interface GetOneCourse {
  type: typeof GET_ONE_COURSE;
  payload: GetOneCourseOutDto;
}

export interface GetOneCourseSuccess {
  type: typeof GET_ONE_COURSE_SUCCESS;
  payload: GetOneCourseOutDto;
}

export interface GetOneCourseError {
  type: typeof GET_ONE_COURSE_ERROR;
  payload: string | boolean;
}

export interface ResetGetOneCourse {
  type: typeof RESET_GET_ONE_COURSE;
  payload: null;
}

export interface State {
  data: GetOneCourseOutDto | null;
  states: {
    loading: boolean;
    success: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
};

export type Actions =
  | GetOneCourse
  | GetOneCourseSuccess
  | GetOneCourseError
  | ResetGetOneCourse;
